import { Button, Stack, TextField, Snackbar, Alert } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { changePasswordApi } from "../tenantProfile/tenantProfile.api";
const ChangePassword = (props) => {
  const { changePassword, handleShowChangePassword } = props;
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleSubmit = () => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      setSnackbarMessage("All fields are required.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }
    if (newPassword !== confirmPassword) {
      setSnackbarMessage("New password and confirm password do not match.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }
    // Call API here to update the password
    const bodyRequest = {
      password: currentPassword,
      newPassword: newPassword,
    };
    changePasswordApi(bodyRequest).then((res) => {

      if (res.data.message == "Incorrect Old Password") {
        setSnackbarMessage("Incorrect Old Password");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      } else if (res.data.message == "Password Changed Successfully") {
        setSnackbarMessage("Password changed successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        return;
      } else if (res.response.status === 404) {
        setSnackbarMessage("Something Went Wrong");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      }
    });
  };

  return (
    <>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        onClose={handleCloseSnackbar}
      >
        <Alert
          severity={
            snackbarSeverity === "success" ? undefined : snackbarSeverity
          }
          onClose={handleCloseSnackbar}
          sx={{
            width: "100%",
            backgroundColor:
              snackbarSeverity === "success" ? "#2196f3" : undefined, // Blue for success
            color: snackbarSeverity === "success" ? "#fff" : undefined, // White text for blue background
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Box sx={{ alignItems: "flex-end", width: 300 }}>
        <Button
          onClick={handleShowChangePassword}
          variant="contained"
          sx={{ textTransform: "capitalize" }}
        >
          Change Password
        </Button>

        {changePassword && (
          <Stack spacing={2} sx={{ mt: 3 }}>
            <TextField
              label="Current Password"
              type="text"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
            />
            <TextField
              label="New Password"
              type="text"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <TextField
              label="Confirm Password"
              type="text"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            {error && (
              <Box sx={{ color: "red", fontSize: "14px" }}>{error}</Box>
            )}
            <Button
              onClick={handleSubmit}
              variant="contained"
              sx={{ textTransform: "capitalize" }}
            >
              Submit
            </Button>
          </Stack>
        )}
      </Box>
    </>
  );
};

export default ChangePassword;
